import Vue from 'vue'
import Router from 'vue-router'
//系统
import login from '../views/login.vue'
import menuManagement from '../views/menuManagement.vue'
import roleManagement from '../views/roleManagement.vue'
import userManagement from '../views/userManagement.vue'

import unit from '../views/BasicInfo/unit.vue'
import sysSetting from '../views/sysSetting.vue'
import home from '../views/home.vue'
import statistics from '../views/statistics.vue'
//用户
import userList from '../views/user/list.vue'
import brand from '../views/BasicInfo/brand.vue'
import butor from '../views/BasicInfo/butor.vue'
import Area from '../views/BasicInfo/Area.vue'

import ListS from '../views/store/ListS.vue'
import ListB from '../views/store/ListB.vue'
import cart from '../views/user/cart.vue'

import addresset from '../views/user/addresset.vue'
import searchList from '../views/user/searchList.vue'

import userProperty from '../views/user/property.vue'
import userWithdraw from '../views/user/integralWithdrawalList.vue'
import userPool from '../views/user/pool.vue'

import integralList from '../views/integral/list.vue'
//供应商列表
import storeList from '../views/store/list.vue'
//商品列表
import goodsList from '../views/goods/list.vue'
import Ptlist from '../views/goods/Ptlist.vue'
import notify from '../views/notify/list'

import goodsfxList from '../views/goods/fxlist.vue'
import goodsdetail from '../views/goods/goodsdetail.vue'
import selectionlist from '../views/goods/selectionlist.vue'

//商品分类
import goodsClass from '../views/goods/goodsClass.vue'

// 订单管理
import orderList from '../views/orderManagement/orderList'
import addorder from '../views/orderManagement/addorder'
import newadd from '../views/orderManagement/newadd'
import edit from '../views/orderManagement/edit'
import afterSaleList from '../views/orderManagement/afterSaleList'

// 物流管理
import logistics from '../views/logistics/index'

import swiper from '../views/carousel/swiper.vue'
import wineCooler from '../views/store/wineCooler.vue'


// 客户管理
import factory from '../views/client/factory'
// 主营分类
import meritoClassify from '../views/client/meritoClassify'
// 客户联系人管理
import linkman from '../views/client/linkman'


// 线路管理
import routeIndex from '../views/route/index'


// 仓库管理
import warehouseIndex from '../views/warehouse/index' //仓库列表
import warehouseDistrict from '../views/warehouse/district' //库区管理
import warehouseLocation from '../views/warehouse/location' //库位管理
import locationCommodity from '../views/warehouse/locationCommodity' //库位商品信息
import locationCommodityBatch from '../views/warehouse/locationCommodityBatch' // 库位商品入库批次信息
import dynamicCollisionInventory from '../views/warehouse/dynamicCollisionInventory' //动碰盘点
import warehouseCustomer from '../views/warehouse/warehouseCustomer' //仓库客户
import queryByCustomer from '../views/warehouse/queryByCustomer' //按客户查询
import storageAge from '../views/warehouse/storageAge' //库龄查询


import enter from '../views/warehouseBill/enter' //入库单
import enterModify from '../views/warehouseBill/enterModify' //入库单的新增和编辑
import warehouseBillPrint from '../views/warehouseBill/print' //入库单的打印
import wrehouseTransferOrder from '../views/warehouseBill/wrehouseTransferOrder' //移库单
import wrehouseTransferAddorder from '../views/warehouseBill/addorder' //移库单操作

import goodStateTransition from '../views/warehouseBill/goodStateTransition' //商品状态转换



import outbound from '../views/warehouseBill/outbound' //出库单
import outboundModify from '../views/warehouseBill/outboundModify' //出库单的新增和编辑
import outPrint from '../views/warehouseBill/outPrint'  //出库单的打印



import stateOfGoods from '../views/orderManagement/stateOfGoods' //货物状态



//供应商管理
import storeManage from '../views/store/storeManage.vue'

import RechargeList from '../views/finance/RechargeList'
import RechargeReview from '../views/finance/RechargeReview'
import depositRecords from '../views/finance/depositRecords'

// 结算单
import SetmentList from '../views/finance/SetmentList.vue'
import accountManag from '../views/finance/accountManag.vue'
import goxuanpin from '../views/goxuanpin.vue'
import { from } from 'core-js/fn/array'
Vue.use(Router)

export default new Router({
	mode: process.env.NODE_ENV == 'production' ? 'hash' : 'history',
	routes: [{
			path: '/',
			name: 'index',
			component: login,
		},
		{
				path: '/goxuanpin',
				name: 'goxuanpin',
				component: goxuanpin,
				 meta: {  hiddenSiderbar: true},
		},
		{ //首页
			path: '/home',
			name: 'home', 
			component: home,
		},
		{ //统计
			path: '/statistics',
			name: 'statistics',
			component: statistics,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //菜单管理
			path: '/menuManagement',
			name: 'menuManagement',
			meta:{keepAlive: true},    // 是否缓存组件
			component: menuManagement,
		},
		{ //角色管理
			path: '/roleManagement',
			name: 'roleManagement',
			meta:{keepAlive: true},    // 是否缓存组件
			component: roleManagement,
		},
		{ //用户管理
			path: '/userManagement',
			name: 'userManagement',
			meta:{keepAlive: true},    // 是否缓存组件
			component: userManagement,
		},
		{ //系统参数管理
			path: '/sysSetting',
			name: 'sysSetting',
			meta:{keepAlive: true},    // 是否缓存组件
			component: sysSetting,
		},
		{ //会员列表
			path: '/user/list',
			name: 'userList',
			meta:{keepAlive: true},    // 是否缓存组件
			component: userList,
		},
		{ //汽车
			path: '/user/cart',
			name: 'cart',
			component: cart,
			meta:{keepAlive: true},    // 是否缓存组件
			
		},
		{ //汽车
			path: '/user/addresset',
			name: 'addresset',
			component: addresset,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //会员充值
			path: '/BasicInfo/brand',
			name: 'brand',
			component: brand,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //会员充值
			path: '/BasicInfo/butor',
			name: 'butor',
			component: butor,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //区域管理
			path: '/BasicInfo/Area',
			name: 'Area',
			meta:{keepAlive: true},    // 是否缓存组件
			component: Area,
		},
		{ //会员查询
			path: '/user/searchList',
			name: 'searchList',
			meta:{keepAlive: true},    // 是否缓存组件
			component: searchList,
		},
		
		
		{ //资产列表
			path: '/user/property',
			name: 'userProperty',
			meta:{keepAlive: true},    // 是否缓存组件
			component: userProperty,
		},
		{ //用户矿池
			path: '/user/pool',
			name: 'userPool',
			component: userPool,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //商品分类
			path: '/goods/goodsClass',
			name: 'goodsClass',
			meta:{keepAlive: true},    // 是否缓存组件
			component: goodsClass,
		},
		
		{ //提币变动记录
			path: '/user/integralWithdrawalList',
			name: 'userWithdraw',
			meta:{keepAlive: true},    // 是否缓存组件
			component: userWithdraw,
		},
		{ //供应商列表
			path: '/store/list',
			name: 'storeList',
			component: storeList,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //供应商S
			path: '/store/ListS',
			name: 'ListS',
			meta:{keepAlive: true},    // 是否缓存组件
			component: ListS,
		},
		{ //供应商B
			path: '/store/ListB',
			name: 'ListB',
			meta:{keepAlive: true},    // 是否缓存组件
			component: ListB,
		},
		{ //商品列表
			path: '/goods/list',
			meta:{keepAlive: true},    // 是否缓存组件
			name: 'goodsList',
			component: goodsList,
		},
		{ //商品列表
			path: '/goods/Ptlist',
			name: 'Ptlist',
			meta:{keepAlive: true},    // 是否缓存组件
			component: Ptlist,
		},
		{ //商品列表
			path: '/goods/goodsdetail',
			name: 'goodsdetail',
			component: goodsdetail,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //分销商选品
			path: '/goods/fxlist/',
			name: 'goodsfxList',
			component: goodsfxList,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //选品列表
			path: '/goods/selectionlist',
			name: 'selectionlist',
			component: selectionlist,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //订单管理
			path: '/orderManagement/addorder',
			name: 'addorder',
			component: addorder,
		},
		{ //订单管理

			path: '/orderManagement/newadd',
			name: 'newadd',
			component: newadd,
			meta:{keepAlive: true},    // 是否缓存组件

		},
		{ //订单管理
			path: '/orderManagement/edit',
			name: 'edit',
			component: edit,
			// meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //订单管理
			path: '/orderManagement/orderList',
			name: 'orderList',
			component: orderList,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //订单管理
			path: '/orderManagement/afterSaleList',
			name: 'afterSaleList',
			component: afterSaleList,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //单位管理
			path: '/BasicInfo/unit',
			name: 'unit',
			component: unit,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		

		{ //物流管理
			path: '/logistics/index',
			name: 'logistics',
			component: logistics,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //导航栏
			path: '/carousel/swiper',
			name: 'swiper',
			component: swiper,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //酒柜管理
			path: '/store/wineCooler',
			name: 'wineCooler',
			component: wineCooler,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		
		{ //供应商管理
			path: '/store/storeManage',
			name: 'storeManage',
			component: storeManage,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //会员充值
			path: '/finance/RechargeList',
			name: 'RechargeList',
			component: RechargeList,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //结算单
			path: '/finance/SetmentList',
			name: 'SetmentList',
			component: SetmentList,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //结算单管理
			path: '/finance/accountManag',
			name: 'accountManag',
			component: accountManag,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //会员充值
			path: '/finance/RechargeReview',
			name: 'RechargeReview',
			meta:{keepAlive: true},    // 是否缓存组件
			component: RechargeReview,
		},
		{ //公告列表
			path: '/notify/list',
			name: 'notify',
			component: notify,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //预存款变更记录
			path: '/finance/depositRecords',
			name: 'depositRecords',
			component: depositRecords,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //客户管理
			path: '/client/factory',
			name: 'factory',
			component: factory,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //主营分类管理
			path: '/client/meritoClassify',
			name: 'meritoClassify',
			component: meritoClassify,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //客户联系人管理
			path: '/client/linkman',
			name: 'linkman',
			component: linkman,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //线路管理
			path: '/route/index',
			name: 'routeIndex',
			component: routeIndex,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //仓库列表
			path: '/warehouse/index',
			name: 'warehouseIndex',
			component: warehouseIndex,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //库区管理
			path: '/warehouse/district',
			name: 'warehouseDistrict',
			component: warehouseDistrict,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //库位管理
			path: '/warehouse/location',
			name: 'warehouseLocation',
			component: warehouseLocation,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //库位商品信息
			path: '/warehouse/locationCommodity',
			name: 'locationCommodity',
			component: locationCommodity,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ // 货物状态
			path: '/orderManagement/stateOfGoods',
			name: 'stateOfGoods',
			component: stateOfGoods,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //仓库客户
			path: '/warehouse/warehouseCustomer',
			name: 'warehouseCustomer',
			component: warehouseCustomer,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //库位商品入库批次信息
			path: '/warehouse/locationCommodityBatch',
			name: 'locationCommodityBatch',
			component: locationCommodityBatch,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //动碰盘点
			path: '/warehouse/dynamicCollisionInventory',
			name: 'dynamicCollisionInventory',
			component: dynamicCollisionInventory,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //按客户查询
			path: '/warehouse/queryByCustomer',
			name: 'queryByCustomer',
			component: queryByCustomer,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{
			path: '/warehouse/storageAge',
			name: 'storageAge',
			component: storageAge,
		},
		{ //入库单查询列表
			path: '/warehouseBill/enter',
			name: 'enter',
			component: enter,
			// meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //入库单的新增和编辑
			path: '/warehouseBill/enterModify',
			name: 'enterModify',
			component: enterModify,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //入库单的打印
			path: '/warehouseBill/print',
			name: 'warehouseBillPrint',
			component: warehouseBillPrint,
		},
		{ //出库单查询列表
			path: '/warehouseBill/outbound',
			name: 'outbound',
			component: outbound,
		},
		{ //出库单的新增和编辑
			path: '/warehouseBill/outboundModify',
			name: 'outboundModify',
			component: outboundModify,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //出库单的打印
			path: '/warehouseBill/outPrint',
			name: 'outPrint',
			component: outPrint,
		},
		{ //移库单
			path: '/warehouseBill/wrehouseTransferOrder',
			name: 'wrehouseTransferOrder',
			component: wrehouseTransferOrder,
		},
		{ //移库单操作
			path: '/warehouseBill/addorder',
			name: 'wrehouseTransferAddorder',
			component: wrehouseTransferAddorder,
			meta:{keepAlive: true},    // 是否缓存组件
		},
		{ //商品状态转换
			path: '/warehouseBill/goodStateTransition',
			name: 'goodStateTransition',
			component: goodStateTransition,
		}
	]
})
